export default __webpack_public_path__ + "static/media/revoke-cancelled-icon.5635be5b.svg";